// extracted by mini-css-extract-plugin
export default {"price":"PaymentCard_price__2V6wf","priceGradient":"PaymentCard_priceGradient__3O1xk"};